import { useTranslation } from 'react-i18next';
import { SegmentInfo, TripSegment } from '../../Summary.model';
import { SummaryArticle } from '../summary-article/SummaryArticle';
import { SummarySubItem } from '../summary-sub-item/SummarySubItem';
import { SummaryAccordion } from '../summary-accordion/SummaryAccordion';
type TripSegmentItemProps = { segment: TripSegment; collapsed: boolean };
export const SummaryTripSegment = ({ segment, collapsed }: TripSegmentItemProps) => {
	const { t } = useTranslation('summary');
	return (
		<>
			<TripSegmentFragment
				fragment={segment.departure}
				route={segment.routeFormatted}
				routeCode={segment.routeCodeFormatted}
				collapsed={collapsed}
			></TripSegmentFragment>

			{!collapsed && (
				<SummaryAccordion textShow={t('FLIGHT_DETAILS_CLOSED')} textHide={t('FLIGHT_DETAILS_OPENED')}>
					<TripSegmentFragment
						fragment={segment.arrival}
						destinationCity={segment.arrival.city}
						collapsed={collapsed}
					></TripSegmentFragment>
					<SummarySubItem text={segment.flight.title}>
						<SummaryArticle text={segment.flight.operatedBy}></SummaryArticle>
						<SummaryArticle text={segment.flight.airplane}></SummaryArticle>
					</SummarySubItem>
					<SummarySubItem text={`${String(t('DURATION'))}  ${segment.duration}`}></SummarySubItem>
					{segment.waitingTime && <SummarySubItem text={segment.waitingTime}></SummarySubItem>}
				</SummaryAccordion>
			)}
		</>
	);
};
SummaryTripSegment.displayName = 'SummaryTripSegment';

const TripSegmentFragment = (props: {
	fragment: SegmentInfo;
	route?: string;
	routeCode?: string;
	destinationCity?: string;
	collapsed: boolean;
}) => {
	const { t } = useTranslation('summary');
	const { fragment, route, routeCode, destinationCity, collapsed = false } = props;
	const { date, airport, terminal, cabin } = fragment;
	return (
		<SummarySubItem
			text={destinationCity ? `${String(t('ARRIVAL'))} ${destinationCity}` : collapsed ? routeCode : route}
		>
			<SummaryArticle text={date}></SummaryArticle>
			{!collapsed && (
				<>
					<SummaryArticle text={airport}></SummaryArticle>
					<SummaryArticle text={`${t('SUMMARY_TERMINAL')}  ${terminal}`}></SummaryArticle>
					{cabin && <SummaryArticle text={`${String(t('CABIN'))}  ${cabin}`}></SummaryArticle>}
				</>
			)}
		</SummarySubItem>
	);
};
TripSegmentFragment.displayName = 'TripSegmentFragment';
